import { getScanOutboundOrder } from "../../../service/api/retail/manual-outbound";

/** 出库方式：与 CashierPayType 对齐 */
export const OUTBOUND_METHODS = [
  { code: "1", name: "现金", icon: "gold-coin-o", iconClass: "cash" },
  { code: "9", name: "微信出库", icon: "wechat", iconClass: "wechat" },
  { code: "10", name: "支付宝出库", icon: "alipay", iconClass: "alipay" },
  { code: "11", name: "会员卡出库", icon: "card", iconClass: "card" },
];

export function formatAmount(val) {
  const n = Number(val);
  return Number.isFinite(n) ? n.toFixed(2) : "0.00";
}

export function getUserInfo() {
  try {
    return JSON.parse(localStorage.getItem("userInfo") || "{}") || {};
  } catch (e) {
    return {};
  }
}

/** 查自助机待支付订单，供支付页展示 */
export async function loadOutboundOrder(orderId) {
  const orderRes = await getScanOutboundOrder(orderId);
  const data = (orderRes && orderRes.data) || {};
  return {
    orderInfo: {
      merchName: data.merchName || "",
      oriTotalAmount: data.oriTotalAmount,
      discountAmount: data.discountAmount,
      payAmount: data.payAmount,
    },
    products: Array.isArray(data.products) ? data.products : [],
  };
}

export function resolvePayFailMsg(e) {
  const raw = (e && (e.msg || e.message)) || "";
  if (/已完成支付|已支付|已付款/.test(raw)) {
    return "付款失败：订单已完成支付";
  }
  if (/网络|timeout|Network/i.test(raw)) {
    return "付款失败：网络异常，请稍后再试";
  }
  if (raw) {
    return `付款失败：${raw}`;
  }
  return "付款失败：未知错误，请联系平台";
}
